import supabase from "../../../shared/database/supabase";
import { Car } from "../model/car";

export const createCar = async (car: Car) => {
  try {
    const { data, error } = await supabase.functions.invoke("create-car", {
      body: JSON.stringify({
        brand: car.brand,
        model: car.model,
        plate: car.plate,
        color: car.color,
        chassis_number: car.chassisNumber,
        insurance_name: car.insuranceName,
        costumer_id: car.costumerId,
        mileage: car.mileage ?? null,
      })
    });

    console.log("createCar response:", { data });

    if (data.error) {
      console.error("Error calling create-car:", data.error);
      return { data: null, error: new Error(data.error.toast_message || data.error.message) };
    }

    return { data: data.data, error: null };
  } catch (err) {
    console.error("Exception in createCar:", err);
    return { data: null, error: err instanceof Error ? err : new Error("Unknown error") };
    // throw err;
  }
};
